"use strict";

exports.__esModule = true;
exports.isString = exports.isRegExp = exports.isObject = exports.isNumber = exports.isNull = exports.isFunction = exports.isBoolean = exports.isArray = void 0;
exports.isToString = isToString;
exports.isTypeof = isTypeof;
exports.isUndefined = void 0;
function isTypeof(value, type) {
  return typeof value === type;
}
var isFunction = exports.isFunction = function isFunction(func) {
  return typeof func === 'function';
};
var isUndefined = exports.isUndefined = function isUndefined(value) {
  return isTypeof(value, 'undefined');
};
var isString = exports.isString = function isString(value) {
  return isTypeof(value, 'string');
};
function isToString(value, type) {
  return Object.prototype.toString.call(value) === "[object " + type + "]";
}
var isArray = exports.isArray = function isArray(value) {
  return isToString(value, 'Array');
};
var isRegExp = exports.isRegExp = function isRegExp(value) {
  return isToString(value, 'RegExp');
};
var isBoolean = exports.isBoolean = function isBoolean(value) {
  return isTypeof(value, 'boolean');
};
var isNumber = exports.isNumber = function isNumber(value) {
  return isTypeof(value, 'number') && !isNaN(value) || isTypeof(value, 'bigint');
};
var isNull = exports.isNull = function isNull(value) {
  return isTypeof(value, 'null');
};
var isObject = exports.isObject = function isObject(value) {
  return !isNull(value) && isTypeof(value, 'object');
};